import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";

import cleanPreviewIcon from "../helpers/clean_svg_string";

class NounProjectPreviewIcon extends React.Component {
    static defaultProps = {};
    static propTypes = {};

    componentDidMount() {
        let iconImageBackground = this.setPreviewIcon(this.props);

        this.setState({
            iconImageBackground: iconImageBackground
        });
    }

    componentWillReceiveProps(nextProps) {
        let iconImageBackground = this.setPreviewIcon(nextProps);

        this.setState({
            iconImageBackground: iconImageBackground
        });
    }

    constructor(props) {
        super(props);

        this.state = {
            iconImageBackground: undefined
        };
    }

    render() {
        let previewClasses = ["iconPreview"];
        if (this.props.isInserting) {
            previewClasses.push("insertIconNow");
        }
        if (this.state.iconImageBackground !== undefined) {
            return (
                <div
                    className={previewClasses.join(" ")}
                    style={{
                        backgroundImage:
                            "url(" + this.state.iconImageBackground + ")"
                    }}
                />
            );
        }

        return null;
    }

    setPreviewIcon(props) {
        let iconImageBackground, newSvg;

        if (props.svg) {
            if (props.isEditable) {
                newSvg = cleanPreviewIcon(
                    props.svg,
                    props.selectedColor,
                    !props.imgSize ? "300px" : props.imgSize
                );

                // Fire callback function provided by the parent component. This is a hack because hero-preview and noun-project-plugin-icon-detail use Flux and Redux data stores so we can't save this data from this component.
                props.cleanedSvgCallback(newSvg);

                iconImageBackground =
                    "data:image/svg+xml;base64," +
                    btoa(unescape(encodeURIComponent(newSvg)));
            } else {
                iconImageBackground = props.icon.icon_url;
            }

            return iconImageBackground;
        }
    }
}

module.exports = NounProjectPreviewIcon;
